module.exports = __webpack_public_path__ + "static/media/woods-of-edenderry.fc495e3b.pdf";